import React from 'react';
import styles from "./PriceRow.module.scss";
import {currencyValueToLabel} from 'gui/components/formikCurrencySelector';
import numeral from 'numeral';
import FormikPriceInput from 'gui/components/formikPriceInput';

interface IPriceEditor {
  name: string;
  min?: number;
  max?: number;
}

interface IPriceRowProps {
  label?: string;
  value?: number | string;
  currency?: number;
  children?: any;
  hideWhenNoValue?: boolean;

  conclusion?: boolean;


  editor?: IPriceEditor;

}

const generateValue = props => [numeral(props.value).format("0,0"), currencyValueToLabel[props.currency]].join(" ");

const PriceRow = (props: IPriceRowProps) =>
  (props.hideWhenNoValue && !(props.value && props.value > 1)) ? (null) :
    (
      <div className={`${styles.PriceRow} ${props.conclusion ? styles.conclusion : ''}`.trim()}>
        <span className={styles.label}>{props.label}</span>
        {props.editor ?
          <FormikPriceInput
            className={`${styles.value} ${styles.input}`}
            name={props.editor.name}
            currency={props.currency}
            min={props.editor.min}
            max={props.editor.max}
            endAdornment={null}
          />
          : <span
            className={styles.value}>{(props.value && props.value > 1) ? generateValue(props) : props.children || 'אין'}</span>}

      </div>);

PriceRow.defaultProps = {
  label: '',
  value: undefined,
  currency: 2,

  hideWhenNoValue: false,
  conclusion: false,
};

export default PriceRow;
